{
  "businessUnit": {
    "list": {
      "deviceCount": "{count} apparecchi|{count} apparecchio|{count} apparecchi"
    },
    "settings": {
      "description": {
        "information": "Informazioni",
        "title": "Informazioni"
      },
      "button": "Impostazioni",
      "users": {
        "title": "Utenti"
      },
      "firmwares": {
        "title": "Firmware"
      },
      "logs": {
        "title": "Giornali"
      }
    },
    "name": "Nome unità aziendale",
    "addOrganization": {
      "button": "Aggiungi un'organizzazione"
    },
    "leave": {
      "title": "Modifica l'unità aziendale"
    }
  },
  "entityLocation": {
    "location": "Luogo",
    "country": "Paese",
    "latitude": "Latitudine",
    "longitude": "Longitudine",
    "timezone": "Fuso orario",
    "countryError": "Il Paese è obbligatorio.",
    "latitudeError": "La latitudine deve essere compresa tra -90 e 90.",
    "longitudeError": "La longitudine deve essere compresa tra -180 e 180.",
    "timezoneError": "Il fuso orario è obbligatorio.",
    "countryPlaceholder": "Scegli il Paese",
    "countrySearchPlaceholder": "Cerca per nome del Paese",
    "countryPopular": "Popolare"
  },
  "superAdministration": {
    "settings": {
      "title": "Modifica {name}",
      "information": {
        "title": "Informazioni",
        "subtitle": "Nome organizzazione",
        "nameLabel": "Etichetta"
      },
      "button": "Impostazioni",
      "users": {
        "title": "Utenti"
      },
      "pki": {
        "title": "PKI",
        "newConnection": "Nuova connessione"
      },
      "logs": {
        "title": "Giornali"
      }
    }
  },
  "organization": {
    "create": {
      "title": "Creazione organizzazione",
      "saveButton": "Crea l'organizzazione"
    },
    "information": {
      "title": "Informazioni sull'organizzazione"
    },
    "name": "Nome organizzazione",
    "type": {
      "label": "Tipo",
      "placeholder": "Seleziona tipo",
      "operator": "Organizzazione dell'operatore",
      "administration": "Organizzazione dell'amministrazione"
    },
    "nameRequiredError": "Il nome è obbligatorio.",
    "typeError": "Il tipo è obbligatorio.",
    "nameLengthError": "Lunghezza compresa tra {min} e {max} caratteri.",
    "settings": {
      "information": {
        "title": "Informazioni"
      },
      "description": {
        "title": "Descrizione"
      },
      "users": {
        "title": "Utenti"
      },
      "operationButton": "Funzionamento",
      "logs": {
        "title": "Giornali"
      },
      "license": {
        "title": "Gestione della licenza"
      }
    },
    "leave": {
      "title": "Modifica l'organizzazione",
      "message": "Tutti i dati non salvati andranno persi."
    }
  },
  "entityAdmin": {
    "lastname": "Cognome amministratore",
    "title": "Informazioni amministratore",
    "firstname": "Nome amministratore",
    "login": "Accesso amministratore",
    "email": "E-mail amministratore",
    "language": "Lingua"
  },
  "country": {
    "GRC": "Grecia",
    "MOZ": "Mozambico",
    "FRA": "Francia",
    "MUS": "Mauritius",
    "BWA": "Botswana",
    "CAF": "Repubblica Centrafricana",
    "FIN": "Finlandia",
    "KAZ": "Kazakistan",
    "MHL": "Isole Marshall",
    "MNE": "Montenegro",
    "MYS": "Malesia",
    "NPL": "Nepal",
    "NZL": "Nuova Zelanda",
    "PER": "Perù",
    "USA": "Stati Uniti d'America",
    "YEM": "Yemen",
    "CMR": "Camerun",
    "CUB": "Cuba",
    "DOM": "Repubblica Dominicana",
    "ITA": "Italia",
    "LBR": "Liberia",
    "SWE": "Svezia",
    "TUN": "Tunisia",
    "WSM": "Samoa",
    "CUW": "Curaçao",
    "DNK": "Danimarca",
    "IDN": "Indonesia",
    "SGP": "Singapore",
    "SLV": "El Salvador",
    "UGA": "Uganda",
    "URY": "Uruguay",
    "VEN": "Venezuela (Repubblica Bolivariana del)",
    "DEU": "Germania",
    "GUM": "Guam",
    "MKD": "Macedonia (ex Repubblica Jugoslava di)",
    "MWI": "Malawi",
    "PAK": "Pakistan",
    "PRT": "Portogallo",
    "BEL": "Belgio",
    "BOL": "Bolivia (Stato plurinazionale di)",
    "COM": "Comore",
    "CHE": "Svizzera",
    "GHA": "Ghana",
    "IRN": "Iran (Repubblica islamica di)",
    "IRQ": "Iraq",
    "JAM": "Giamaica",
    "NLD": "Paesi Bassi",
    "POL": "Polonia",
    "VAT": "Città del Vaticano",
    "AFG": "Afghanistan",
    "DZA": "Algeria",
    "HKG": "Hong Kong",
    "LAO": "Repubblica Democratica Popolare Laotiana",
    "NRU": "Nauru",
    "TKM": "Turkmenistan",
    "ZMB": "Zambia",
    "AUS": "Australia",
    "BHS": "Bahamas",
    "BIH": "Bosnia-Erzegovina",
    "CZE": "Repubblica Ceca",
    "KOR": "Corea (Repubblica di)",
    "PHL": "Filippine",
    "VCT": "San Vincenzo e le Grenadine",
    "ARM": "Armenia",
    "AZE": "Azerbaigian",
    "BDI": "Burundi",
    "BGD": "Bangladesh",
    "ECU": "Ecuador",
    "ETH": "Etiopia",
    "GAB": "Gabon",
    "GMB": "Gambia",
    "HTI": "Haiti",
    "KIR": "Kiribati",
    "MAC": "Macao",
    "MMR": "Myanmar",
    "PRI": "Porto Rico",
    "QAT": "Qatar",
    "SVK": "Slovacchia",
    "TGO": "Togo",
    "UKR": "Ucraina",
    "CAN": "Canada",
    "MLI": "Mali",
    "MNP": "Isole Marianne Settentrionali",
    "SDN": "Sudan",
    "BRB": "Barbados",
    "FJI": "Figi",
    "KGZ": "Kirghizistan",
    "MAF": "Saint Martin (parte francese)",
    "MRT": "Mauritania",
    "ZWE": "Zimbabwe",
    "CA-QC": "Quebec",
    "CHL": "Cile",
    "HRV": "Croazia",
    "SAU": "Arabia Saudita",
    "ASM": "Samoa americana",
    "BMU": "Bermuda",
    "COD": "Congo (Repubblica Democratica del Congo)",
    "CRI": "Costa Rica",
    "GIN": "Guinea",
    "IMN": "Isola di Man",
    "JPN": "Giappone",
    "SLB": "Isole Salomone",
    "SMR": "San Marino",
    "SUR": "Suriname",
    "TCA": "Isole Turks e Caicos",
    "ATG": "Antigua e Barbuda",
    "COG": "Congo",
    "HND": "Honduras",
    "KNA": "Saint Kitts e Nevis",
    "ROU": "Romania",
    "STP": "Sao Tome e Principe",
    "ZAF": "Sudafrica",
    "BGR": "Bulgaria",
    "BRN": "Brunei Darussalam",
    "CYP": "Cipro",
    "FSM": "Micronesia (Stati federali di)",
    "MAR": "Marocco",
    "MDA": "Moldavia (Repubblica di)",
    "MDG": "Madagascar",
    "MNG": "Mongolia",
    "SLE": "Sierra Leone",
    "TLS": "Timor Est",
    "VNM": "Vietnam",
    "AGO": "Angola",
    "BLZ": "Belize",
    "HUN": "Ungheria",
    "IRL": "Irlanda",
    "KWT": "Kuwait",
    "MDV": "Maldive",
    "NER": "Niger",
    "NIC": "Nicaragua",
    "PSE": "Palestina",
    "TWN": "Taiwan",
    "ARG": "Argentina",
    "COL": "Colombia",
    "JOR": "Giordania",
    "NAM": "Namibia",
    "SRB": "Serbia",
    "TJK": "Tagikistan",
    "CPV": "Capo Verde",
    "GEO": "Georgia",
    "KOS": "Repubblica del Kosovo",
    "LUX": "Lussemburgo",
    "OMN": "Oman",
    "RUS": "Federazione Russa",
    "SOM": "Somalia",
    "SYC": "Seychelles",
    "TCD": "Ciad",
    "TUV": "Tuvalu",
    "AND": "Andorra",
    "BHR": "Bahrein",
    "BRA": "Brasile",
    "DJI": "Gibuti",
    "DMA": "Dominica",
    "EST": "Estonia",
    "ISR": "Israele",
    "MCO": "Monaco",
    "MLT": "Malta",
    "SEN": "Senegal",
    "SXM": "Sint Maarten (parte olandese)",
    "VUT": "Vanuatu",
    "ABW": "Aruba",
    "BEN": "Benin",
    "BLR": "Bielorussia",
    "CYM": "Isole Cayman",
    "GIB": "Gibilterra",
    "GNB": "Guinea-Bissau",
    "GRD": "Grenada",
    "IND": "India",
    "LBY": "Libia",
    "LCA": "Santa Lucia",
    "LVA": "Lettonia",
    "PRK": "Corea (Repubblica Democratica Popolare di)",
    "SSD": "Sud Sudan",
    "TTO": "Trinidad e Tobago",
    "ALB": "Albania",
    "BTN": "Bhutan",
    "CIV": "Costa d'Avorio",
    "LKA": "Sri Lanka",
    "PAN": "Panama",
    "SYR": "Repubblica araba siriana",
    "UZB": "Uzbekistan",
    "AUT": "Austria",
    "EGY": "Egitto",
    "ERI": "Eritrea",
    "FRO": "Isole Faroe",
    "GNQ": "Guinea equatoriale",
    "GRL": "Groenlandia",
    "GUY": "Guyana",
    "LTU": "Lituania",
    "MEX": "Messico",
    "NOR": "Norvegia",
    "RWA": "Ruanda",
    "SWZ": "Swaziland",
    "THA": "Thailandia",
    "ARE": "Emirati Arabi Uniti",
    "ESP": "Spagna",
    "GBR": "Regno Unito di Gran Bretagna e Irlanda del Nord",
    "ISL": "Islanda",
    "KEN": "Kenya",
    "LSO": "Lesotho",
    "NGA": "Nigeria",
    "PLW": "Palau",
    "PNG": "Papua Nuova Guinea",
    "BFA": "Burkina Faso",
    "CHN": "Cina",
    "KHM": "Cambogia",
    "LBN": "Libano",
    "LIE": "Liechtenstein",
    "PRY": "Paraguay",
    "SVN": "Slovenia",
    "TON": "Tonga",
    "TUR": "Turchia",
    "TZA": "Tanzania",
    "VGB": "Isole Vergini (britanniche)",
    "GTM": "Guatemala"
  },
  "relation": {
    "since": "Da: {date}",
    "delete": {
      "confirm": {
        "title": "Elimina la relazione",
        "description": "Vuoi davvero eliminare la relazione con {name}?"
      }
    }
  },
  "relations": {
    "affiliations": {
      "title": "Affiliazione",
      "add": {
        "button": "Aggiungi un’affiliazione"
      },
      "parentEntity": {
        "title": "Controllante"
      },
      "childrenEntities": {
        "title": "Entità affiliate"
      }
    },
    "delegations": {
      "title": "Delega",
      "add": {
        "button": "Aggiungi una delega"
      }
    },
    "title": "Relazioni",
    "add": {
      "createLink": "Crea un link con un’organizzazione esistente",
      "createOrganization": "Crea una nuova organizzazione"
    },
    "uploadIdCard": {
      "title": "Carica la scheda ID dell’organizzazione",
      "validation": {
        "fileMandatory": "Il file deve essere in formato .JSON",
        "fileEmpty": "Il file non deve essere vuoto",
        "fileSize": "Il file deve avere dimensioni inferiori a 750MB"
      }
    },
    "contact": {
      "administrator": "Amministratore:",
      "noContact": "Nessun contatto identificato",
      "referentUser": {
        "title": "Contatto dell’organizzazione",
        "description": "Contatto nominato per le richieste operative, commerciali o di assistenza relative a questa organizzazione.",
        "selectUser": "Seleziona un utente",
        "modified": "Modifica il contatto"
      }
    }
  }
}
